import {
  Badge,
  Box,
  Button,
  Icon,
  TextInput,
  theme
} from "@prismicio/editor-ui"

interface Props {
  badge?: string
  disabled: boolean
  loading: boolean
  placeholder: string
  value: string
  onValueChange: (value: string) => void
  onSend: () => void
}

export function AiPrompt(props: Props) {
  const {
    badge,
    disabled,
    loading,
    placeholder,
    value,
    onValueChange,
    onSend
  } = props

  return (
    <Box gap={8} alignItems="center">
      {/* TODO: We shouldn't create one-off input kinds with Boxes; reuse/modify FormInput instead. */}
      <Box
        flexGrow={1}
        borderRadius={6}
        border
        overflow="hidden"
        height={theme.size.large}
      >
        <Box
          backgroundColor="grey2"
          border={{ right: true }}
          justifyContent="center"
          alignItems="center"
          padding={{ inline: 8 }}
        >
          <Icon name="prismic" color="grey12" size="medium" />
        </Box>
        {badge && (
          <Box alignItems="center" padding={{ left: 12, right: 8 }}>
            <Badge size="medium" title={badge} maxWidth={150} />
          </Box>
        )}
        <Box
          flexDirection="column"
          flexGrow={1}
          padding={{ left: badge ? 0 : 12, right: 12 }}
        >
          <TextInput
            maxLength={220}
            readOnly={loading}
            placeholder={placeholder}
            value={value}
            onValueChange={onValueChange}
            onKeyDown={(event) => {
              if (event.key !== "Enter") return
              if (disabled) return
              onSend()
            }}
          />
        </Box>
      </Box>
      <Button
        size="large"
        startIcon="arrowForward"
        loading={loading}
        disabled={disabled}
        onClick={onSend}
      />
    </Box>
  )
}
